<template>
<div>
  <div class="content-header text-center">
    <h2>Cluster Explorer</h2>
  </div>
  <div class="container-fluid">
    <div class="row">
        <div class="col">
            <div class="form-group">
                <label for="clusterSelect">Cluster</label>
                <select id="clusterSelect" class="form-select" v-model="selectedCluster" @change="submitSelection">
                    <option v-for="cluster in clusterData" :value="cluster.number" :key="cluster.number">
                        {{ cluster.title }}
                    </option>
                </select>
            </div>
        </div>
    </div>

    <div class="row gx-0"  v-if="clusterData && clusterData.length > 0">
        <div class="col-sm h-100">
            <div class="card">
	            <div class="container-fluid">
                    <div class="row gx-0 h-100">
                        <div class="col-md-8">
                            <div class="container-fluid">
                                <div class="row gx-0">
                                    <div class="col-sm">
                                        <div class="lifestyle-header d-flex align-items-center">
                                            <div class="header-icon d-flex align-items-center">
                                                <img :src="`/static/icons/Cluster_${getSelectedClusterData.number}.svg`" class="img-fluid">
                                            </div>
	                                        <div class="header-title d-flex align-items-center">
                                                <h3 class="h-100 align-middle my-auto">{{ getSelectedClusterData.title }}</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row h-100">
                                    <div class="col-sm">
                                        <div class="lifestyle-main-text py-5">
                                            <p>{{ getSelectedClusterData.prose }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 h-100 my-auto lifestyle-list">
                            <div class="lifestyle-main-text var">
                                <p><strong><i class="fas fa-birthday-cake"></i> Age:</strong> {{ getSelectedClusterData.motivations[0].age }}</p>
                                <p><strong><i class="fas fa-bullseye"></i> Lifestage:</strong> {{ getSelectedClusterData.motivations[0].lifestage }}</p>
                                <p><strong><i class="fas fa-sack-dollar"></i> Income:</strong> {{ getSelectedClusterData.motivations[0].income }}</p>
                                <p><strong><i class="fas fa-map-marker-alt"></i> Example Communities:</strong> {{ getSelectedClusterData.motivations[0].communities }}</p>
                                <p><strong><i class="fas fa-book-open"></i> Education:</strong> {{ getSelectedClusterData.motivations[0].education }}</p>
                                <!-- p><strong><i class="fas fa-car"></i> Drives:</strong> {{ getSelectedClusterData.motivations[0].drives }}</p>
                                <p><strong><i class="fas fa-tv"></i> Watches:</strong> {{ getSelectedClusterData.motivations[0].watches }}</p -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- end static lifestyle card -->
    <!-- start explorer nav -->
        <div class="d-flex align-items-start bg-white"  v-if="clusterData && clusterData.length > 0">
        <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                <button class="nav-link  btn btn-sm btn-default active" id="v-pills-motivations-tab" data-bs-toggle="pill" data-bs-target="#v-pills-motivations" type="button" role="tab" aria-controls="v-pills-motivations" aria-selected="true">Motivations</button>
                <button class="nav-link  btn btn-sm btn-default" id="v-pills-values-tab" data-bs-toggle="pill" data-bs-target="#v-pills-values" type="button" role="tab" aria-controls="v-pills-values" aria-selected="false">Values</button>
                <button class="nav-link btn btn-sm btn-default" id="v-pills-online_behavior-tab" data-bs-toggle="pill" data-bs-target="#v-pills-online_behavior" type="button" role="tab" aria-controls="v-pills-online_behavior" aria-selected="false">Online Behavior</button>
                <button class="nav-link btn btn-sm btn-default" id="v-pills-technology-tab" data-bs-toggle="pill" data-bs-target="#v-pills-technology" type="button" role="tab" aria-controls="v-pills-technology" aria-selected="false">Technology</button>
                <button class="nav-link btn btn-sm btn-default" id="v-pills-transportation-tab" data-bs-toggle="pill" data-bs-target="#v-pills-transportation" type="button" role="tab" aria-controls="v-pills-transportation" aria-selected="false">Transportation</button>
                <button class="nav-link btn btn-sm btn-default" id="v-pills-travel-tab" data-bs-toggle="pill" data-bs-target="#v-pills-travel" type="button" role="tab" aria-controls="v-pills-travel" aria-selected="false">Travel</button>
                <button class="nav-link btn btn-sm btn-default" id="v-pills-dining-tab" data-bs-toggle="pill" data-bs-target="#v-pills-dining" type="button" role="tab" aria-controls="v-pills-dining" aria-selected="false">Dining Out</button>
                <button class="nav-link btn btn-sm btn-default" id="v-pills-home-tab" data-bs-toggle="pill" data-bs-target="#v-pills-home" type="button" role="tab" aria-controls="v-pills-home" aria-selected="false">Household</button>
                <button class="nav-link btn btn-sm btn-default" id="v-pills-healthcare-tab" data-bs-toggle="pill" data-bs-target="#v-pills-healthcare" type="button" role="tab" aria-controls="v-pills-healthcare" aria-selected="false">Healthcare</button>
                <button class="nav-link btn btn-sm btn-default" id="v-pills-media-tab" data-bs-toggle="pill" data-bs-target="#v-pills-media" type="button" role="tab" aria-controls="v-pills-media" aria-selected="false">Media</button>



                <button class="nav-link btn btn-sm btn-default" id="v-pills-diningin-tab" data-bs-toggle="pill" data-bs-target="#v-pills-diningin" type="button" role="tab" aria-controls="v-pills-diningin" aria-selected="false">Dining In</button>
                <button class="nav-link btn btn-sm btn-default" id="v-pills-gaming-tab" data-bs-toggle="pill" data-bs-target="#v-pills-gaming" type="button" role="tab" aria-controls="v-pills-gaming" aria-selected="false">Gaming</button>
                <button class="nav-link btn btn-sm btn-default" id="v-pills-entertainment-tab" data-bs-toggle="pill" data-bs-target="#v-pills-entertainment" type="button" role="tab" aria-controls="v-pills-entertainment" aria-selected="false">Entertainment</button>
                <button class="nav-link btn btn-sm btn-default" id="v-pills-sustain-tab" data-bs-toggle="pill" data-bs-target="#v-pills-sustain" type="button" role="tab" aria-controls="v-pills-sustain" aria-selected="false">Sustainability</button>
                <button class="nav-link btn btn-sm btn-default" id="v-pills-fitness-tab" data-bs-toggle="pill" data-bs-target="#v-pills-fitness" type="button" role="tab" aria-controls="v-pills-fitness" aria-selected="false">Fitness</button>
                <button class="nav-link btn btn-sm btn-default" id="v-pills-charity-tab" data-bs-toggle="pill" data-bs-target="#v-pills-charity" type="button" role="tab" aria-controls="v-pills-charity" aria-selected="false">Charity</button>
                <button class="nav-link btn btn-sm btn-default" id="v-pills-diy-tab" data-bs-toggle="pill" data-bs-target="#v-pills-diy" type="button" role="tab" aria-controls="v-pills-diy" aria-selected="false">DIY</button>
        </div> 
<div class="tab-content card-body h-100" id="v-pills-tabContent"  v-if="clusterData && clusterData.length > 0">
    <div class="tab-pane fade show active" id="v-pills-motivations" role="tabpanel" aria-labelledby="v-pills-motivations-tab">
        <div class="container-fluid p-3">
            <div class="row">
                <div class="col">
                    <div v-html="$options.filters.forceBr(addlinebreaks(getSelectedClusterData.motivations[0].summary))"></div>
                </div>
            </div>
        </div>
    </div>
    <div class="tab-pane fade" id="v-pills-values" role="tabpanel" aria-labelledby="v-pills-values-tab">
        <div class="container-fluid p-3">
            <div class="row">
                <div class="col">
                    <div v-html="$options.filters.forceBr(addlinebreaks(getSelectedClusterData.values[0].content))"></div>
                </div>
            </div>
        </div>
    </div>
    <div class="tab-pane fade" id="v-pills-online_behavior" role="tabpanel" aria-labelledby="v-pills-online_behavior-tab">
        <div class="container-fluid p-3">
            <div class="row">
                <div class="col">
                    <div v-html="$options.filters.forceBr(addlinebreaks(getSelectedClusterData.online_behavior[0].content))"></div>
                </div>
            </div>
        </div>
    </div>
    <div class="tab-pane fade" id="v-pills-technology" role="tabpanel" aria-labelledby="v-pills-technology-tab">
        <div class="container-fluid p-3">
            <div class="row">
                <div class="col">
                        <div v-html="$options.filters.forceBr(addlinebreaks(getSelectedClusterData.technology[0].content))"></div>
                </div>
            </div>
        </div>
    </div>
    <div class="tab-pane fade" id="v-pills-transportation" role="tabpanel" aria-labelledby="v-pills-transportation-tab">
        <div class="container-fluid p-3">
            <div class="row">
                <div class="col-md-8"><div v-html="$options.filters.forceBr(addlinebreaks(getSelectedClusterData.transportation[0].content))"></div></div>
                <div class="col-md-4"><small><div v-html="$options.filters.forceBr(addhorizrules(getSelectedClusterData.transportation[0].sidebar))"></div></small></div>
            </div>
        </div>
    </div>
    <div class="tab-pane fade" id="v-pills-travel" role="tabpanel" aria-labelledby="v-pills-travel-tab">
        <div class="container-fluid p-3">
            <div class="row">
                <div class="col-md-8"><div v-html="$options.filters.forceBr(addlinebreaks(getSelectedClusterData.travel[0].content))"></div></div>
                <div class="col-md-4"><small><div v-html="$options.filters.forceBr(addhorizrules(getSelectedClusterData.travel[0].sidebar))"></div></small></div>
            </div>
        </div>
    </div>
    <div class="tab-pane fade" id="v-pills-dining" role="tabpanel" aria-labelledby="v-pills-dining-tab">
        <div class="container-fluid p-3">
            <div class="row">
                <div class="col-md-8"><div v-html="$options.filters.forceBr(addlinebreaks(getSelectedClusterData.dining[0].content))"></div></div>
                <div class="col-md-4"><small><div v-html="$options.filters.forceBr(addhorizrules(getSelectedClusterData.dining[0].sidebar))"></div></small></div>
            </div>
        </div>
    </div>
    <div class="tab-pane fade" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
        <div class="container-fluid p-3">
            <div class="row">
                <div class="col">
                        <div v-html="$options.filters.forceBr(addlinebreaks(getSelectedClusterData.home[0].content))"></div>
                </div>
            </div>
        </div>
    </div>
    <div class="tab-pane fade" id="v-pills-healthcare" role="tabpanel" aria-labelledby="v-pills-healthcare-tab">
        <div class="container-fluid p-3">
            <div class="row">
                <div class="col">
                    <div v-html="$options.filters.forceBr(addlinebreaks(getSelectedClusterData.healthcare[0].content))"></div>
                </div>
            </div>
        </div>
    </div>
    <div class="tab-pane fade" id="v-pills-media" role="tabpanel" aria-labelledby="v-pills-media-tab">
         <div class="container-fluid p-3">
            <div class="row">
                <div class="col-md-8"><div v-html="$options.filters.forceBr(addlinebreaks(getSelectedClusterData.media[0].content))"></div></div>
                <div class="col-md-4"><small><div v-html="$options.filters.forceBr(addhorizrules(getSelectedClusterData.media[0].sidebar))"></div></small></div>
            </div>
        </div>
    </div>
    <!-- new areas -->
    <div class="tab-pane fade" id="v-pills-diningin" role="tabpanel" aria-labelledby="v-pills-diningin-tab">
        <div class="container-fluid p-3">
            <div class="row">
                <div class="col">
                    <div v-html="$options.filters.forceBr(addlinebreaks(getSelectedClusterData.diningin[0].content))"></div>
                </div>
            </div>
        </div>
    </div>

    <div class="tab-pane fade" id="v-pills-gaming" role="tabpanel" aria-labelledby="v-pills-gaming-tab">
        <div class="container-fluid p-3">
            <div class="row">
                <div class="col">
                    <div v-html="$options.filters.forceBr(addlinebreaks(getSelectedClusterData.gaming[0].content))"></div>
                </div>
            </div>
        </div>
    </div>

    <div class="tab-pane fade" id="v-pills-entertainment" role="tabpanel" aria-labelledby="v-pills-entertainment-tab">
        <div class="container-fluid p-3">
            <div class="row">
                <div class="col">
                    <div v-html="$options.filters.forceBr(addlinebreaks(getSelectedClusterData.entertainment[0].content))"></div>
                </div>
            </div>
        </div>
    </div>

    <div class="tab-pane fade" id="v-pills-sustain" role="tabpanel" aria-labelledby="v-pills-sustain-tab">
        <div class="container-fluid p-3">
            <div class="row">
                <div class="col">
                    <div v-html="$options.filters.forceBr(addlinebreaks(getSelectedClusterData.sustainability[0].content))"></div>
                </div>
            </div>
        </div>
    </div>

    <div class="tab-pane fade" id="v-pills-fitness" role="tabpanel" aria-labelledby="v-pills-fitness-tab">
        <div class="container-fluid p-3">
            <div class="row">
                <div class="col">
                    <div v-html="$options.filters.forceBr(addlinebreaks(getSelectedClusterData.fitness[0].content))"></div>
                </div>
            </div>
        </div>
    </div>

    <div class="tab-pane fade" id="v-pills-charity" role="tabpanel" aria-labelledby="v-pills-charity-tab">
        <div class="container-fluid p-3">
            <div class="row">
                <div class="col">
                    <div v-html="$options.filters.forceBr(addlinebreaks(getSelectedClusterData.charity[0].content))"></div>
                </div>
            </div>
        </div>
    </div>

    <div class="tab-pane fade" id="v-pills-diy" role="tabpanel" aria-labelledby="v-pills-diy-tab">
        <div class="container-fluid p-3">
            <div class="row">
                <div class="col">
                    <div v-html="$options.filters.forceBr(addlinebreaks(getSelectedClusterData.diy[0].content))"></div>
                </div>
            </div>
        </div>
    </div>




  </div>
</div>

    <!-- end explorer nav -->
  </div>
  </div>
</template>
<script>
import axios from "axios";
// import jsonData from '../cluster_data.json';
export default {
  name: "ClusterExplorer",
  components: {  },
  props: {
    passedData: {
      type: String,
      default() {
        return "Dataset";
      },
    },
  },
  data() {
    return {
      selectedCluster: '3',
      clusterData: []
    };
  },
  methods: {
    submitSelection() {
        console.log('Selected cluster:', this.selectedCluster);
    },
    addlinebreaks(thisvar) {
        return thisvar.replace(/(\r\n|\n|\r)/g, '<br>\n');
    },
    addhorizrules(thisvar) {
        return thisvar.replace(/(\r\n|\n|\r)/g, '<hr>\n');
    },
    getClusterData() {
      //console.log('getting current chat');
      //let formData = new FormData();
      //formData.append('cluster', this.selectedCluster);
        axios.post('/get_cluster_data').then(
          (response) => {        
                //console.log('cluster data response: '+JSON.stringify(response.data));
                this.clusterData = response.data;
          })
        .catch(
          (error) => {
          this.errorMessage = error.message;
        console.error("There was an error in importing SRC data!", error);
      });
    },
  },
  filters: {
    forceBr(text) {
        return text.replace(/&lt;br&gt;/g, '<br>');
    }
    },
  computed: {
    getSelectedClusterData() {
        return this.clusterData.find(cluster => cluster.number === this.selectedCluster) || {};
    }
    },
    watch: {
    selectedCluster(newValue) {
        console.log('Selected cluster changed:', newValue);
        // You can perform any additional actions here when the cluster changes
    }
    },
    mounted() {
        this.getClusterData();
    }
};
</script>